import { render, staticRenderFns } from "./ModalCallAttention.vue?vue&type=template&id=9b26ea42&scoped=true&lang=pug&"
import script from "./ModalCallAttention.vue?vue&type=script&lang=ts&"
export * from "./ModalCallAttention.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCallAttention.vue?vue&type=style&index=0&id=9b26ea42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b26ea42",
  null
  
)

export default component.exports